export const cartCardsAction = (cartCards) => {
    return {
        type: "CART_CARDS",
        payload: cartCards,
    };
};
